module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p35",
      "title": "35"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "spinach_pesto_egg_bakes"
    }
  }, [_vm._v("Spinach-Pesto Egg Bakes")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("4 servings")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 15 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 50 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup pine nuts")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup frozen cut leaf spinach (from 14-oz bag), thawed, squeezed to drain")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup cottage cheese")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup shredded Monterey Jack cheese (4 oz)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup basil pesto")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("4")]), _vm._v(" eggs, beaten")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup milk")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" medium tomato, chopped")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup shredded Parmesan cheese (1 oz)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }), _vm._v(" Fresh basil leaves, if desired")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 375°F. Lightly spray 4 (10-oz) custard cups or ramekins with cooking spray. Place cups on cookie sheet with sides.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Sprinkle pine nuts in ungreased 8-inch skillet. Cook over medium heat 5 to 7 minutes, stirring frequently until nuts begin to brown, then stirring constantly until light brown.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" In medium bowl, mix spinach, cottage cheese, Monterey Jack cheese, pesto and toasted nuts. Stir in eggs and milk until well blended. Divide spinach mixture evenly among cups.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" Bake 25 to 30 minutes or until set. Cool 2 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw in refrigerator overnight. Unwrap; microwave 1 egg bake on High about 1 minute or until hot. Top with tomato and Parmesan cheese; garnish with basil.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 420; Total Fat 32g (Saturated Fat 12g, Trans Fat 0g); Cholesterol 255mg; Sodium 680mg; Total Carbohydrate 8g (Dietary Fiber 2g); Protein 25g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" ½ Starch, ½ Vegetable, 2½ Medium-Fat Meat, ½ High-Fat Meat, 3 Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_note"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("Fresh Idea")]), _vm._v(" Change up the cheese here—try Cheddar, Swiss or mozzarella. They are all sold shredded, making these individual breakfast bakes even easier.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9952aef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p035.vue
// module id = 150
// module chunks = 0